<template>
    <div style="background-color: #FFFFFF;">
        <div >
            <!-- MENU -->
            <div class="menu menu-bg-blue menublue">
                <b-container class=" align-items-center"> 
                    <b-row class="justify-content-center"  >
                    <b-col>
                        <b-navbar toggleable="lg" type="dark">
                        <b-navbar-brand :href="$router.resolve({ name: 'home'}).href"><img src="../assets/icn_logo.svg" id="logo"/></b-navbar-brand>
                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav v-model="isNavbarExpanded">
                        <b-navbar-nav class="ml-auto align-items-center">
                            <b-nav-item :href="$router.resolve({ name: 'about'}).href">ABOUT</b-nav-item>
                            <b-nav-item :href="$router.resolve({ name: 'services'}).href">SERVICES</b-nav-item>
                            <b-nav-item :href="$router.resolve({ name: 'certifications'}).href">CERTIFICATIONS</b-nav-item>
                            <b-nav-item :href="$router.resolve({ name: 'carriers'}).href" >GET A QUOTE</b-nav-item>
                            <b-nav-item class="boton" :href="$router.resolve({ name: 'contactus'}).href">CONTACT US</b-nav-item>
                            <b-nav-item class="mobil" href="https://www.facebook.com/BC.LOGISTICS.MX"><img src="../assets/icn_facebook.svg" alt="facebook logo"></b-nav-item>
                            <b-nav-item class="mobil"  href="https://www.linkedin.com/company/bclogistics/"><img src="../assets/icn_linkedin.svg" alt="linkedin logo"></b-nav-item>
                            <b-row> 
                            <b-col>
                                <b-nav-item class="desktop" href="https://www.facebook.com/BC.LOGISTICS.MX"><img src="../assets/icn_facebook.svg" alt="facebook logo"></b-nav-item>
                            </b-col>
                            <b-col
                            ><b-nav-item class="desktop"  href="https://www.linkedin.com/company/bclogistics/"><img src="../assets/icn_linkedin.svg" alt="linkedin logo"></b-nav-item></b-col>
                        </b-row>
                        </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                    </b-col>
                    </b-row>
                </b-container>
            </div>
            </div>
        
            <b-container class="privacy">
                <div v-html="privacyPolicyHtml"></div>
            </b-container>
    </div>
</template>

<script>
export default {
data() {
return {
    color: '#01326C',
  privacyPolicyHtml: '',
};
},  mounted() {
    this.loadPrivacyPolicy();
    if (this.$route.name === 'privacy-policy' && window.performance) {
      if (performance.navigation.type === 1) {
        this.$router.push({ name: 'home' });
      }
    }
  },
methods: {
loadPrivacyPolicy() {
  fetch('/html/policy.html')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(html => {
      this.privacyPolicyHtml = html;
    })
    .catch(error => {
      console.error('Error fetching privacy policy:', error);
    });
},
handleScroll() {
    const blueSections = document.querySelectorAll('.blue-background'); // Asume que todas las secciones azules tienen esta clase.
    let isBlue = true; // Asumimos que el fondo no es azul inicialmente

    // Revisamos cada sección azul para ver si el scroll está dentro de sus límites
    blueSections.forEach((section) => {
      if (
        window.scrollY >= section.offsetTop &&
        window.scrollY <= (section.offsetTop + section.offsetHeight)
      ) {
        isBlue = true;
      }
    });

    // Actualizamos isBlueBackground basado en si encontramos alguna sección azul bajo el scroll actual
    this.isBlueBackground = isBlue;
  }
},
};
</script>



<style scoped>
 
h1, h2, h3, p {
  font-size: calc(1rem + 1vw); 
}
h1{
  font-size: 70px;
  line-height:70px ;
  font-weight: 600;
}
  
p{
  font-size:18px ;
  line-height: 24px;
  font-weight: 400;
}
 
h3{
  font-size: 45px;
  line-height: 50px;
  font-weight: 500;
} 

h4{
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 0;
}
p.subtitle{
  font-size: 25px;
  line-height: 37.5px;
  font-weight: 500;
  margin-top: 15px;
}

.privacy{
    padding-top: 12%;
    padding-bottom: 5%;
}
.highlight{
  color:#D0BD55 !important;
}
.blue-highlight{
  color:#5E8ACC !important;
  font-weight:600;
  font-size: 18px;
  line-height: 25px;
}
.boton, .boton a.nav-link, .boton.btn{
  background-color: #D0BD55;
  border-radius: 5px;
  max-width: 296px;
  max-height: 65px;
  text-align: center;
  border: none;
  color:#01326C !important;
  font-weight: 500 !important;
  
  padding: 7px 15px 7px 15px;
}

.desktop{
    display: none;
}
.boton.btn{
  font-size: 20px !important;
}
.ml-auto{
  margin-left: auto;
}

.menu-bg-blue {
  background-color: #01326C; 
  transition: background-color 0.3s ease;  
} 
.menublue {
    background-color:#01326C;
  }

video, img {
  max-width: 100%;
  height: auto;
  object-fit: cover;  
}
.menu{
  padding-top: 2%;
  padding-bottom: 2%;
  position: fixed;
  max-width: 100%;
  z-index: 4;
  width: 100%;
}
a.nav-link{
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color:#FFFFFF;
}

.nav-item{
  margin-right: 10px;
}


@media (max-width: 1220px){

    .privacy{
        padding-top: 15%;
    }
}
@media (max-width: 825px){

.privacy{
    padding-top: 20%;
}
}
@media (max-width: 650px){

.privacy{
    padding-top: 25%;
}
}
@media (max-width: 465px){

.privacy{
    padding-top: 35%;
}
}

*{
  text-decoration: none;
  transition:ease;
}
a{
  color:#01326C;
}
h1, h2, h3, p {
  font-size: calc(1rem + 1vw); 
}
h1{
  font-size: 70px;
  line-height:70px ;
  font-weight: 600;
}
  
p{
  font-size:18px ;
  line-height: 24px;
  font-weight: 400;
}
 
h3{
  font-size: 45px;
  line-height: 50px;
  font-weight: 500;
} 

h4{
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 0;
}
p.subtitle{
  font-size: 25px;
  line-height: 37.5px;
  font-weight: 500;
  margin-top: 15px;
}
.highlight{
  color:#D0BD55 !important;
}
.blue-highlight{
  color:#5E8ACC !important;
  font-weight:600;
  font-size: 18px;
  line-height: 25px;
}
.boton, .boton a.nav-link, .boton.btn{
  background-color: #D0BD55;
  border-radius: 5px;
  max-width: 296px;
  max-height: 65px;
  text-align: center;
  border: none;
  color:#01326C !important;
  font-weight: 500 !important;
  
  padding: 7px 15px 7px 15px;
}

.boton.btn{
  font-size: 20px !important;
}
/* MARGINS */
.ml-auto{
  margin-left: auto;
}
#blue, .founded, .values, .brokerage, .services, .certifications, .yards {
  min-height: 50vh;  
}
/* MENU */

.menu-bg-blue {
  background-color: #01326C; 
  transition: background-color 0.3s ease;  
} 


video, img {
  max-width: 100%;
  height: auto;
  object-fit: cover;  
}
.menu{
  padding-top: 2%;
  padding-bottom: 2%;
  position: fixed;
  max-width: 100%;
  z-index: 4;
  width: 100%;
}
a.nav-link{
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color:#FFFFFF;
}

.nav-item{
  margin-right: 10px;
}
 
/* BANNER */

.overlay{
  background-image: url("../assets/img_homebanner_overlay.png");
  z-index: 2;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100vw; 
  height: 100vw; 
}
 
.banner{
  position: relative;
  padding: 0; 
  margin: 0;  
  overflow: visible;
  max-width: none;
  overflow-x: hidden;  
}
 
#videohome{
  position:absolute;
  object-fit: cover;
  overflow-x: hidden;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100vw; 
  height: 100vw;  
 
}
/* FOUNDED */

.founded{
   background-image: url('../assets/img_about.jpg');
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
    height:70vh;
   text-align: center;
}

/* CORE VALUES */

.values{
  border-top: #2558A5 4px solid;
}

.values img{
  margin-top: 35px;
}

/* BROKERAGE */

.overlay2{
  z-index: 3;
  position: relative;
  background: linear-gradient(to bottom, rgba(13, 52, 108, 0.9) 0%, rgba(13, 52, 108, 0.9) 0%);
  background-size: cover;
 
  height: 70vh; 
}

#videohome2{
  position:absolute;
  object-fit: contain;
  overflow-x: hidden;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100vw; 
  height: 70vh; 
    object-fit: cover; 
 
}

.brokerage{
  position: relative;
  text-align: center;
  align-items: center;
}

/* BROKERAGE */

/* SERVICES */

.select{
  border: 1px solid #FFFFFF4D;
  padding: 0px 0px 0px 0px;
  max-width:922px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;  
 
}

.select .servicios {
  background-color: transparent;
  border: none;
  padding: 0.5rem 1rem;  
  margin: 0;  
}

 
.servicios h4 {
  margin: 0;
  padding: 0;
}

.select .text-center h4{
  color:#FFFFFF80;
}
.select .btn{
  background-color: transparent;
  border: none;
  width: max-content;
}

.services{
  padding-top: 5%;
}

.servicios.active{
  background:#D9D9D91A;
  border-radius: 5px;
  max-width: 373px;
}

.quote.active{
  border: 1px solid #FFFFFF;
  background-color: transparent;
}

.servicios.active h4{
  color:#FFFFFF !important;
}

.quote.active h4{
  color:#FFFFFF !important;
}

.desktop{
  display: none;
}
/* CERTIFICATIONS */
.certifications{
   background-image: url('../assets/img_certifications.png');
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
   height:70vh;
   text-align: center;
}
/* YARDS */

.yards{
   background-image: url('../assets/img_map.png');
   background-position: center;
   background-repeat: no-repeat;
   background-size: contain;
   height: 80vh;
   z-index: 1;
  background-position: right 0;
}

#calexico{
  position: absolute;
  top: 26%;
  right: 32%;
  z-index:3;
}


#mexicali{
  position: absolute;
  top: 38%;
  right: 39%;
  z-index:3;
}

/* QUOTE */ 

.quote{
  border: 1px solid #FFFFFF4D;
  background-color: transparent;
  padding: 10px 30px 10px 30px;
  border-radius: 5px;
  width:auto;
}

#carriers .text-center .btn{
  background-color: transparent;
  border: none;
  width: auto;
}
.quote  h4{
  color:#FFFFFF80;
}
/* CONTACT */ 

#contact{
  background-image: url('../assets/img_contact.jpg');
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
  height: 80vh;
 
}

/* FORM 1 */ 

.form-control{
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 158.46%);
  background-color:#1A477A;
    border: none;
  }

  .form-floating{
    position: relative;
    display: flex;
    line-height: 10px;
    font-size: 16px;
    color:#FFFFFF80;
    font-weight: 500;
    margin-top: 18px;
  }

  .form-floating > .form-control{
    position: relative;
    color: #FFFFFF;
    line-height: 20px;
    font-size: 18px;
    margin-top: 5px;
    font-weight: 300;
    height: 65px;
 
  }
 
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 1rem 0.75rem; /* Padding to match input padding */
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

.form-control:focus,
.input:focus,
.input:active,
.form-control:focus{
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 158.46%);
  background-color:#1A477A;
  border: none !important;
  outline: none !important;
  box-shadow: none !important; 
}

.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
      background: transparent;
      color: #FFFFFF !important;
      font-weight: 500;
      border: none;
      outline: none;
      
  }

  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
      -webkit-transform:translateY(0%) translateX(0rem);
      transform: translateY(0%) translateX(0rem);
      z-index: 20;
      color: #FFFFFF !important;
      font-weight: 500;
      border: none ;
      font-size: 16px;
      line-height: 10px;
      margin-bottom: 0px;
  }
 
.inline-checkbox-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;  
  gap: 5px; 
}

/* Style applied to each checkbox */
.inline-checkbox-group .mb-2  {
  display: inline-flex;
   
   
}
.inline-checkbox-group label{
  margin-left:10px !important; 
}
.custom-control-label label{
  color:black;
}
input[type="checkbox"] {
  margin: 30px 30px 30px 4px !important;
}
.materialCheckbox label.custom-control-label {
    margin-left: 5px !important;
}

.form-floating textarea{
  overflow-y: hidden !important;
}

#carriers{
  padding-bottom:10vh;
}
.inline-checkbox-group {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 158.46%);
  background-color:#1A477A; /* This color should match your form's background */
  padding: 10px;
  border-radius: 5px;
 
}


.inline-checkbox-group .mb-2 input, .custom-control-input, .inline-checkbox-group .custom-control-input{
  margin-right:35px;
}

 
@media (max-width: 1400px){
  .phone{
    margin-top: 0 !important;
  }

  #contact .row.justify-content-center.align-content-center.py-5, #contact{
    height: 90vh !important; 
  }
}

@media (max-width: 991px){
  .hide{
    display: none;
  }


  .yards{
    background-position-x: 500px;
  }


  #calexico{
 
 
  right: 12%;
 
}

#contact .row.justify-content-center.align-content-center.py-5, #contact{
    height: 130vh !important; 
  }
#mexicali{
 
 
  right: 19%;
 
}
#videohome,.overlay .align-content-end.py-5,.overlay{
  height: 120vh !important; 

}



  .menublue {
    background-color:#01326C;
  }

  .quote1 .form-floating  {
    position: relative;
    display: flex;
    line-height: 10px;
    font-size: 14px;
    color:#FFFFFF80;
    font-weight: 500;
    margin-top: 18px;
  }
  .nav-item {
  padding: 0.35rem 1rem;
  font-size: 1rem;
  color: white; /* Or another color that matches your branding */
  transition: background-color 0.3s ease;
}
  .desktop{
  display: flex;
}

.mobil{
  display: none;
}
.phone{
    margin-top:10% !important;
  }
}


@media (max-width: 768px){
  #contact .justify-content-center.align-content-center.py-5,  #contact,  #videohome,.overlay .align-content-end.py-5,.overlay{
    height:140vh !important;
  }
  #carriers .justify-items-center.align-content-center {
    height: auto !important;
}
  .phone{
    margin-top:10% !important;
  }

 .services .d-flex.align-items-start.justify-content-center.justify-content-md-start{
  justify-content:start !important;
 }

 .starhide{
  display: none;
 }

 .menublue {
    background-color:#01326C;
  }

  #nav-collapse .ml-auto.align-items-center{
    align-items:center !important;
  }

  .nav-item img {
    display: inline-block;  
    width: auto;  
    margin-bottom: 0;  
  }

  .yards{
  background-position: left -100px;
  }

  #calexico{
    display: none;
  }


  #mexicali{
    display: none
  }
  .nav-item {
  padding: 0.35rem 1rem;
  font-size: 1rem;
  color: white; /* Or another color that matches your branding */
  transition: background-color 0.3s ease;
}

.desktop{
  display: flex;
}

.mobil{
  display: none;
}

}


@media (max-width: 568px){

    #carriers .justify-items-center.align-content-center {
    height: auto !important;
}
  .menu {
    padding: 1rem;
  }
  h1{
  font-size: 50px;
  line-height:50px ;
}
 
h3{
  font-size: 35px;
  line-height: 40px;
} 

h4{
  font-size: 20px;
  line-height: 30px;
}
 
.blue-highlight{
  font-size: 18px;
  line-height: 25px;
}
#videohome,.overlay .align-content-end.py-5,.overlay{
    height:130vh !important;
  }


  #logo {
    width: 200px;
  }

   .navbar-toggler{
    margin-right:10%;
  }
  .navbar.navbar-dark.navbar-expand-lg{
    justify-content: end;
  }

  #startstar{
    width: 200px;
    padding-top:40px;
  }

  .blue-background .pb-5.mb-5.container{
    margin-bottom: 0 !important;
  }

  .values img {
    margin-top: 10px;
}

.form-floating,  .quote1 .form-floating {
    position: relative;
    display: flex;
    line-height: 10px;
    font-size: 15px !important;
    color:#FFFFFF80;
    font-weight: 500;
    margin-top: 18px;
  }

 
}
</style>